import { useMutation } from "react-query";
import { updateBusinessType } from "../../../../../actions/Utilities/BusinessType";
import { toast } from "../../../../../components/toastNotification";
import { IBusinessType } from "../type/BusinessTypeInterface";
import {
  businessTypeRefetching,
  editStateAgreementBusinessType,
} from "../atoms/atoms";
import { useRecoilState, useSetRecoilState } from "recoil";

const useUpdateBusinessType = () => {
  const setActionAddState = useSetRecoilState(editStateAgreementBusinessType);
  const [isReFetching, setIsReFetching] = useRecoilState(
    businessTypeRefetching
  );
  const { mutate } = useMutation(
    (Data: IBusinessType) => updateBusinessType(Data),
    {
      onSuccess: (res) => {
        switch (true) {
          case res == "Success":
            toast.fire(
              "Success",
              "Business Type Updated Successfully",
              "success"
            );
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Business Type Updated Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Updating Business Type failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Updating Business Type failed ",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire(
              "Updating Business Type failed ",
              `Error: ${res}`,
              "error"
            );
            break;
          default:
            toast.fire(
              "Updating Business Type failed",
              `${res.Message}`,
              "error"
            );
        }
        // Redirect to View
        setActionAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire("Update Business Type failed", `Error: ${error}`, "error");
      },
    }
  );
  return mutate;
};
export default useUpdateBusinessType;
